
import { Link, useHistory } from "react-router-dom";
// reactstrap components
import {
  NavLink,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import auth from "authProvider";

const AdminNavbar = (props) => {
  const history = useHistory();
  const onLogout = () => {
    auth.logout();
    //window.location.reload();
    history.push("/")
  }
  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
          <Nav className="align-items-center " navbar>
            <div style={{ marginRight: 10 }}><Link to='/settings'><IcomoonReact iconSet={iconSet} color="white" size={16} icon="technician-icon" /></Link></div>
            {/* <NavLink href='/settings'>
              <IcomoonReact iconSet={iconSet} color="white" size={16} icon="technician-icon" />
            </NavLink> */}
            <IcomoonReact style={{ marginTop: '5' }} onClick={() => onLogout()} iconSet={iconSet} color="white" size={16} icon="logout" />
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
